import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5ed438a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex relative mb-x5" }
const _hoisted_2 = { class: "c-input__label c-input__label--has-value" }
const _hoisted_3 = { class: "field-divider relative w-70" }
const _hoisted_4 = { class: "field-divider relative w-70" }
const _hoisted_5 = { class: "relative w-full" }
const _hoisted_6 = {
  key: 0,
  class: "o-text-caption text-roman absolute inset-b-0 mt-35"
}
const _hoisted_7 = {
  key: 1,
  class: "o-text-caption text-dusty-grey absolute inset-b-0 mt-35"
}

import InputText from '@/shared/form/InputText.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed, ref, watch } from 'vue';
import InputCheckbox from '@/shared/form/InputCheckbox.vue';
import { isExists } from 'date-fns';
import useBirthday from '@/b2c/profile/useBirthday';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBirthdayInput',
  setup(__props) {

const labels = useBlockLabels();
const { birthdayDateAsObject, birthdayAsDate } = useBirthday();

const birthdayIsValidOrNull = ref<boolean>(true);

const birthdayDateModel = ref<Date | string | undefined>();

const birthDayModel = ref<string>(birthdayDateAsObject.value.day ?? '');
const birthDayRef = ref<HTMLDivElement>();

const birthMonthModel = ref<string>(birthdayDateAsObject.value.month ?? '');
const birthMonthRef = ref<HTMLDivElement>();

const birthYearRef = ref<HTMLDivElement>();
const birthYearModel = ref<string>(birthdayDateAsObject.value.year ?? '');

const insertLeadingZeroInPreviousModels = (formatAll = false) => {
    if (birthDayModel.value?.length === 1) {
        birthDayModel.value = `0${birthDayModel.value}`;
    }

    if (birthMonthModel.value?.length === 1 && formatAll) {
        birthMonthModel.value = `0${birthMonthModel.value}`;
    }
};

insertLeadingZeroInPreviousModels(true);

const preventFormSubmit = computed(() => {
    const hasAnyValue = !!birthYearModel.value || !!birthMonthModel.value || !!birthDayModel.value;
    return hasAnyValue ? !dateExists.value : false;
});

const showErrorMessage = computed(() => {
    const invalidDate = allFieldsHaveExpectedValues.value ? !dateExists.value : false;
    return anyFieldIsInvalid.value || unfinishedFieldInput.value || invalidDate;
});

const allFieldsHaveExpectedValues = computed(() => {
    return birthYearModel.value?.length === 4 && birthMonthModel.value?.length === 2 && birthDayModel.value?.length === 2;
});

const dateExists = computed(() => {
    if (!allFieldsHaveExpectedValues.value) {
        return false;
    }

    const birth = {
        day: parseInt(birthDayModel.value, 10),
        month: parseInt(birthMonthModel.value, 10),
        year: parseInt(birthYearModel.value, 10),
    };

    return isExists(birth.year, birth.month - 1, birth.day);
});

const unfinishedFieldInput = computed(() => {
    // @ts-ignore
    const anyFieldHasFocus = birthDayRef.value?.isFocused || birthMonthRef.value?.isFocused || birthYearRef.value?.isFocused;
    const anyFieldHasValue = birthYearModel.value?.length === 4 || birthMonthModel.value?.length === 2 || birthDayModel.value?.length === 2;
    return !anyFieldHasFocus && anyFieldHasValue && !allFieldsHaveExpectedValues.value;
});

const anyFieldIsInvalid = computed(() => {
    // @ts-ignore
    const showBirthDayAsInvalid = birthDayRef.value?.isFocused ? birthDayModel.value?.length === 2 && !birthDayRef.value?.meta?.valid : !birthDayRef.value?.meta?.valid;
    // @ts-ignore
    const showBirthMonthAsInvalid = birthMonthRef.value?.isFocused ? birthMonthModel.value?.length === 2 && !birthMonthRef.value?.meta?.valid : !birthMonthRef.value?.meta?.valid;
    // @ts-ignore
    const showBirthYearAsInvalid = birthYearRef.value?.isFocused ? birthYearModel.value?.length === 4 && !birthYearRef.value?.meta?.valid : !birthYearRef.value?.meta?.valid;
    return showBirthDayAsInvalid || showBirthMonthAsInvalid || showBirthYearAsInvalid;
});

watch(birthDayModel, () => {
    maybeSetFocusInNextField(birthDayModel, birthMonthRef);
    setBirthdayDateModel();
});

watch(birthMonthModel, () => {
    insertLeadingZeroInPreviousModels();
    maybeSetFocusInNextField(birthMonthModel, birthYearRef);
    setBirthdayDateModel();
});

watch(birthYearModel, () => {
    insertLeadingZeroInPreviousModels(true);
    setBirthdayDateModel();
});

watch(preventFormSubmit, (value) => {
    birthdayIsValidOrNull.value = !value;
});

const setBirthdayDateModel = () => {
    if (allFieldsHaveExpectedValues.value) {
        birthdayDateModel.value = birthdayAsDate(birthDayModel.value, birthMonthModel.value, birthYearModel.value);
    }
};

const maybeSetFocusInNextField = (currentModel, nextRef) => {
    const inputHasReachedMax = currentModel.value && currentModel.value.length === 2;
    if (inputHasReachedMax && !showErrorMessage.value) {
        nextRef.value.$refs.inputField.focus();
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, _toDisplayString(_unref(labels).birthday), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InputText, {
        key: "birthDay",
        ref_key: "birthDayRef",
        ref: birthDayRef,
        modelValue: birthDayModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((birthDayModel).value = $event)),
        name: "birthDay",
        placeholder: _unref(labels).placeholderDay,
        class: _normalizeClass({'invalid-birthday': _unref(showErrorMessage)}),
        minlength: "2",
        maxlength: "2",
        inputmode: "numeric",
        type: "text",
        "input-clear": false,
        "show-errors": false
      }, null, 8, ["modelValue", "placeholder", "class"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(InputText, {
        key: "birthMonth",
        ref_key: "birthMonthRef",
        ref: birthMonthRef,
        modelValue: birthMonthModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((birthMonthModel).value = $event)),
        name: "birthMonth",
        placeholder: _unref(labels).placeholderMonth,
        class: _normalizeClass({'invalid-birthday': _unref(showErrorMessage)}),
        minlength: "2",
        maxlength: "2",
        type: "text",
        inputmode: "numeric",
        "input-clear": false,
        "show-errors": false,
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (insertLeadingZeroInPreviousModels()))
      }, null, 8, ["modelValue", "placeholder", "class"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(InputText, {
        key: "birthYear",
        ref_key: "birthYearRef",
        ref: birthYearRef,
        modelValue: birthYearModel.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((birthYearModel).value = $event)),
        name: "birthYear",
        minlength: "4",
        maxlength: "4",
        placeholder: _unref(labels).placeholderYear,
        class: _normalizeClass({'invalid-birthday': _unref(showErrorMessage)}),
        type: "text",
        inputmode: "numeric",
        "input-clear": false,
        "show-errors": false,
        onFocus: _cache[4] || (_cache[4] = ($event: any) => (insertLeadingZeroInPreviousModels(true)))
      }, null, 8, ["modelValue", "placeholder", "class"])
    ]),
    (_unref(showErrorMessage))
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(labels).birthdayError), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(labels).birthdayHint), 1)),
    _createVNode(InputCheckbox, {
      modelValue: birthdayIsValidOrNull.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((birthdayIsValidOrNull).value = $event)),
      name: "birthdayIsValidOrNull",
      class: "hide-from-view-but-include-in-form-data",
      "aria-hidden": "true"
    }, null, 8, ["modelValue"]),
    _createVNode(InputText, {
      modelValue: birthdayDateModel.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((birthdayDateModel).value = $event)),
      name: "birthdayDate",
      type: "text",
      class: "hide-from-view-but-include-in-form-data",
      "aria-hidden": "true"
    }, null, 8, ["modelValue"])
  ]))
}
}

})